import { FC } from 'react'
import styles from './header-nav-menu.module.scss'
import MenuItem from './MenuItem'
import headerNavList from '@/utils/lists/header-nav.list'

type HeaderNavMenuProps = {}

const HeaderNavMenu: FC<HeaderNavMenuProps> = ({}) => {
  return (
    <nav className={styles.menu}>
      <ul
        itemScope
        itemType="https://schema.org/SiteNavigationElement"
        className={styles['menu-list']}
      >
        {headerNavList.map((item, index) => (
          <MenuItem key={index} {...item} />
        ))}
      </ul>
    </nav>
  )
}

export default HeaderNavMenu
